// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.GMap__Wrapper {\r\n  width: 100%;\r\n  height: 400px;\n}\r\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
